/**
 ** Search form component
 **/
import React from 'react';
import {bool, string, func} from 'prop-types';
import classNames from 'classnames';
import {timesCircle} from 'react-icons-kit/fa/timesCircle';
import {lock} from 'react-icons-kit/fa/lock';
import {search} from 'react-icons-kit/fa/search';
import Icon from '../Icon';
import styles from './Search.scss';
import TextInput from '../forms/TextInput';

const Search = ({
  className,
  value,
  onChange,
  readOnly,
  errorMessage,
  ...inputProps // assuming that everything not in props is a pass-through to the input
}) => {
  const onClickIcon = () => {
    onChange('');
  };

  const _onChange = ({target}) => {
    onChange(target.value);
  };

  return (
    <div className={classNames(styles.Search, className)}>
      <TextInput
        type="search"
        className={styles.input}
        value={value}
        onChange={_onChange}
        readOnly={readOnly}
        errorMessage={errorMessage}
        {...inputProps} />
      {!errorMessage &&
        <button className={styles.iconWrap} onClick={onClickIcon} disabled={readOnly}>
          {readOnly
            ? <Icon icon={lock} className={styles.icon} />
            : value
              ? <Icon icon={timesCircle} size={19} className={styles.icon} />
              : <Icon icon={search} className={styles.icon} /> }
        </button> }
    </div>
  );
};

Search.propTypes = {
  className: string,
  value: string,
  onChange: func.isRequired,
  readOnly: bool,
  errorMessage: string,
};

Search.defaultProps = {
  className: '',
  value: '',
  errorMessage: undefined,
};

export default Search;
